import { render, staticRenderFns } from "./Topsa.vue?vue&type=template&id=2f0f5bb6&scoped=true"
import script from "./Topsa.vue?vue&type=script&lang=js"
export * from "./Topsa.vue?vue&type=script&lang=js"
import style0 from "./Topsa.vue?vue&type=style&index=0&id=2f0f5bb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0f5bb6",
  null
  
)

export default component.exports